import { Box, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

export interface ChatMessageListProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function ChatMessageList(props: ChatMessageListProps) {
  const { children, sx } = props;

  return (
    <Box
      sx={mergeSxProps(
        {
          display: "flex",
          flexDirection: "column",
          gap: 4,
        },
        sx
      )}
    >
      {children}
    </Box>
  );
}
